export enum IsCompleted {
  incompleted = 0,
  both = 2,
  completed = 3
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/model/enum/is-completed.ts